import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { locationSearchSchema } from "../lib/searchParams";
import Pricing from "../pages/Pricing";

export const Route = createFileRoute("/pricing")({
	validateSearch: zodValidator(locationSearchSchema),
	component: Pricing,
});
